// extracted by mini-css-extract-plugin
module.exports = {"container":"SubSectionBar_container__3V6p5"};